import { Link } from 'react-router-dom'
import cn from 'clsx'
import {Space, Pagination} from 'antd'
import useStore from 'base/store'
import {PermissionType} from 'common/types'
import styles from './AllUsersList.module.scss'
// import {isProjectRequest} from 'modules/project'
import {
  Box,
  Block,
  Text,
  Empty,
  UserAvatar,
  FolderBookmarkSecondIcon,
  RequestThirdIcon,
  SearchIcon,
  DotsMenu,
  Modal,
  // IconButton, DotsIcon, StarCheckIcon, MoneyBanknotesRotatedSecondIcon, SuitcaseIcon, UserProfileIcon, CentsMoney,
} from 'common/components'
import {useOpen} from 'common/hooks'
import {maybePluralize, formatDate} from 'common/helpers'
import {User as UserInterface} from '..'
import UserForm from './UserForm'

interface UsersListProps {
  items: UserInterface[]
  page: number
  total: number
  setPage: (page: number) => void
}
interface UserProps {
  user: UserInterface
}
interface ProjectsProps {
  user: UserInterface
  items: any[]
}
// interface ProjectLinksProps {
//   items: any[]
// }

const projectPostfix = (n:number) => ((n > 1) ? ' projects' : ' project')

export const AllUsersList:React.FC<UsersListProps> = ({
  items, 
  total, page, setPage,
}) => {
  return (
    (!items.length) ?
    <Empty title="search results"
      icon={<SearchIcon width={40} height={40} />}
    /> :
    <>
      <ul>
        {items.map((item) => (
          <User key={item.uuid} user={item} />
        ))}
      </ul>
      <Pagination
        showSizeChanger={false}
        current={page}
        total={total}
        pageSize={10}
        onChange={setPage}
      />
    </>
  )
}

const User = ({user}: UserProps) => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  return (
    <Block as="li" className={cn(styles.item)}>
      <div>
        <UserAvatar size={48} src={user.photo} alt={user.firstName} />
      </div>
      <div>
        <Text weight="demiBold">
          {user.firstName} {user.lastName}
        </Text>
        <Text className={styles.details} size="xs" color="grey">
          <span>{user.email}</span>
          <br />
          <span>+64 {user.phone.slice(3)}</span>
        </Text>
      </div>
      <div className={styles['item-top']}>

        <Box align="center">
          <p className={styles.text}>ID {user.displayId}</p>
          <Text size="xs" color="grey">
            Registered {formatDate(user.createdAt, 'fifth')}
          </Text>
        </Box>
        <Box weight="demiBold" color={!!(user.borrowersCount) ? undefined : 'grey'}>
          <Space>
            {maybePluralize(user.borrowersCount, 'borrower')}
          </Space>
        </Box>
        <Box weight="demiBold" color={!!(user.brokersCount) ? undefined : 'grey'}>
          <Space>
            {maybePluralize(user.brokersCount, 'broker')}
          </Space>
        </Box>

        <Projects
          user={user}
          items={user?.projects || []}
        />

        <Box weight="demiBold" color={undefined}>
          {/* {Boolean(requests.length) && ( */}
            <Space>
              <RequestThirdIcon />
              {maybePluralize(user.requestsCount, 'request')}
            </Space>
          {/* )} */}
          {/* <ProjectLinks items={requests} /> */}
        </Box>
      </div>
      
      <Box align="center">
      { permissions?.includes('edit user') && 
        <Menu data={user} />  
      }
      </Box>
      
    </Block>
  )
}

const Menu = ({data}: {
  data:any
}) => {
  const [isOpen, handleOpen, handleClose] = useOpen()
  return (
    <>
      <DotsMenu className={styles.menu}
        items={[{label: 'Edit', onClick: handleOpen}]}
      />
      <Modal title="Edit user" open={isOpen} onCancel={handleClose}>
        <UserForm onClose={handleClose} initialValues={data} />
      </Modal>
    </>
  )
}

const Projects = ({user, items}: ProjectsProps) => {
  const projects = items // .filter((project) => project.status !== 'pending')
  const statusCount = projects.reduce(
    (accu, item) => {
      if (
        [
          'opened'
        ].includes(item.status)
      ) {
        accu.opened += 1
      } else if (
        [
          'closed'
        ].includes(item.status)
      ) {
        accu.closed += 1
      }

      return accu
    },
    {opened: 0, closed: 0} // signed: 0, 
  )
  // console.log(statusCount)
  // const requests = items.filter((project) => isProjectRequest(project))
  const searchStr = `${user.firstName || ''} ${user.lastName || ''}`
  // searchStr = (!!user.firstName) ? user.firstName :
  //         (!!user.lastName) ? user.lastName : ''

  return (
    <>
      <Box weight="demiBold" color={undefined} className={styles['projects-field']}>
        <Link to="/projects" state={{ search: searchStr.trim() }} >
          <Text color="black" className={styles['projects-field-icon']}>
            <FolderBookmarkSecondIcon />
          </Text>
          <Text color="black" size="md" weight="demiBold">
            {statusCount.opened} opened
            {projectPostfix(statusCount.opened)}
          </Text>
          <Text color="grayer" size="xs" mt={2}>
            {statusCount.closed} closed
            {projectPostfix(statusCount.closed)}
          </Text>
        </Link>
      </Box>
    </>
  )
}
